module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Miss Manners’ Guide to Contagious Etiquette ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("copyright © 2020 by Judith Martin. All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case  of reprints in the context of reviews. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Andrews McMeel Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("a division of Andrews McMeel Universal")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("1130 Walnut Street, Kansas City, Missouri 64106")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('a', {
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("www.andrewsmcmeel.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ISBN: ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("978-1-5248-6482-8")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Editor: Allison Adler")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Art Director: Holly Swayne")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Production Editor: Margaret Daniels")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ebook Developer: Kristen Minter")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Attention: Schools and Businesses")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase  for educational, business, or sales promotional use. For information, please  e-mail the Andrews McMeel Publishing Special Sales Department: ")]), _c('a', {
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("specialsales@amuniversal.com")])]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "_CN-",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Miss Manners’ Guide "), _c('br'), _vm._v("to Contagious Etiquette")])]), _vm._v(" "), _c('p', {
    staticClass: "init-para-1"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("O")]), _vm._v("f what purpose or relevance is etiquette in a time of social distancing?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tBecause etiquette is a social code of behavior, Miss Manners has always promised not to annoy you with rules when you are home alone. And now so many of us are. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tStill, the importance of considerate behavior ought to be obvious for those who are not literally alone, but sequestered with others. The old argument for “just being able to be myself at home,” which always turned out to mean indulging in doses of slovenliness and selfishness, always led to no good. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tEven truly solitary confinement—with the exception of being able to connect through the blessings of electronics—benefits from retaining some of the basics of civilized life. Prisoners in the Civil War pleaded for spoons, so that they wouldn’t feel like animals eating with their hands. Anyone who has been bedridden knows that the simple routines of getting dressed and sitting at a table for meals have a stabilizing effect. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tObviously it is the heroic moral virtues that we most prize in times of crisis. But there are underlying principles that manners share with morality, and the small virtues that arise from concern for others are crucial in close quarters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tMiss Manners has long suffered from the popular misconception of etiquette as pertaining only to “society” in the sense of the rich and frivolous, and the illusion that normal people behave naturally. There is nothing like social distancing to serve as a reminder that society means all of us, and that behaving like our better selves benefits everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "dots"
  }, [_vm._v("• • •")]), _vm._v(" "), _c('p', {
    staticClass: "dear3-dots"
  }, [_c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("DEAR MISS MANNERS—")]), _vm._v("I have an older sister who continues to go out to socialize and posts photos of herself with friends on social media, despite the current need for everyone to stay home who can. These are not outings to get needed supplies nor to go to an essential job.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\t I tried to gently mention how we should not be going out at all if it can be helped, and she insisted it was only to see a few people, so she was fine. I am worried not only for her own safety, as she is of mature years, but also for that of her 13-year-old daughter who has had a history of pneumonia, her friends who are her seniors, and society at large. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tShe lives where there is a great population of senior citizens, and also where there have been less stringent preventative orders than elsewhere. How does one press such a dire subject for everyone’s safety to someone who isn’t taking the situation seriously?")]), _vm._v(" "), _c('p', {
    staticClass: "gentle-reader3"
  }, [_c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("GENTLE READER—")]), _vm._v("Etiquette cannot substitute for responsible public officials in setting health policy during a pandemic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\t Miss Manners does not say this to invalidate your all-too-familiar problem, but rather to acknowledge the heartbreaking results when we are forced to use the wrong tool for the job. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tWhat she can suggest is treating the situation as you would any irresponsible health choice made by a close relative. Your sister is endangering herself, your niece, and her friends: this is worth saying to her even if you are unable to convince her. \t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When normalcy returns, we will just have to remember that such strong solutions are reserved for dire and imminent threats—they are not a license to harangue passing strangers about the consequences of overeating.")]), _vm._v(" "), _c('p', {
    staticClass: "dots"
  }, [_vm._v("• • •")]), _vm._v(" "), _c('p', {
    staticClass: "dear3-dots"
  }, [_c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("DEAR MISS MANNERS—")]), _vm._v("My grandmother taught me the value of writing letters and, though I haven’t done that in quite some time, I think the current outbreak is providing us ample opportunity to be kind in simple ways. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tMy son and I are going to send letters to the local nursing home, which we’ve already discussed with the home to avoid any issues. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tWhat would be the most appropriate way to greet these folks who we don’t know? I know we could use a standard, “Wishing you well,” etc., but I’d like to be as kind as possible to make sure they know that we really are thinking of them and hope they are well.")]), _vm._v(" "), _c('p', {
    staticClass: "gentle-reader3"
  }, [_c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("GENTLE READER—")]), _vm._v("This is a kindness to your son, as well as to the residents, who are now deprived of outside contact, even from their families. Miss Manners considers empathy to be the most important quality a parent should seek to develop. And knowing how to write a graceful letter will be of surprisingly good use to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tThe letters should introduce yourselves as their neighbors, perhaps with a drawing or photograph. If the nursing home’s administration will give you a list of the residents, you can address them by their honorifics and surnames, even if there are many of them. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tThe staff could also tell you if it would be practical for you to propose dropping off books, magazines, or videos, or perhaps greeting them from the sidewalk or a virtual meeting. But the letters alone should be valuable in reminding these people that they are not abandoned by the outside world. ")]), _vm._v(" "), _c('p', {
    staticClass: "dots"
  }, [_vm._v("• • •")]), _vm._v(" "), _c('p', {
    staticClass: "dear3-dots"
  }, [_c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("DEAR MISS MANNERS—")]), _vm._v("I live in a tight-knit community comprised of mostly seniors, with about 20 homes on a street that ends in a cul-de-sac. It’s the sort of community where neighbors look in on one another and take care of each other, and where very little goes unnoticed. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("\tA good friend who lives several houses away phoned to say that he was sick with what he suspected was the flu, and that he needed help. Due to the possibility of COVID-19, I did as much as I could without actually entering his house, including leaving food and medicine on his doorstep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span'), _vm._v("\tWhen his health did not improve, I felt it was necessary to call an ambulance, which arrived with sirens blaring and lights flashing, drawing the attention of everyone in the immediate vicinity. He was taken to the hospital where he luckily tested negative for COVID-19, but he had suffered a small stroke, all of which he recounted to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span'), _vm._v("\tMy neighbors were anxious to know what had happened and descended on me for answers, and I told them what I knew. When I spoke to my friend in the hospital later, he told me that he appreciated my help, that it had been all right to tell people that he had tested negative for the virus, but that I should not have disclosed the fact that he’d had a stroke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span'), _vm._v("\tNow that my friend is in rehab, people are asking me about his condition, putting me in an awkward position. What should I do from now on, without either violating my friend’s privacy or embarrassing those who are expressing concern?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span'), _vm._v("\tI did not sign on to be a press secretary, particularly one that’s doing a bad job!")]), _vm._v(" "), _c('p', {
    staticClass: "gentle-reader3"
  }, [_c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("GENTLE READER")]), _c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("—")]), _vm._v("Having cared for your neighbor in these crises, you can honorably resign as spokesperson. If he is well enough to criticize, Miss Manners would consider him well enough to take charge of his health reports, or to designate someone else to do so.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a3ba5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissMannersContagious1.vue
// module id = 63
// module chunks = 0